"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCommunityLeadersResponseToJSON = exports.GetCommunityLeadersResponseFromJSONTyped = exports.GetCommunityLeadersResponseFromJSON = void 0;
var _1 = require("./");
function GetCommunityLeadersResponseFromJSON(json) {
    return GetCommunityLeadersResponseFromJSONTyped(json, false);
}
exports.GetCommunityLeadersResponseFromJSON = GetCommunityLeadersResponseFromJSON;
function GetCommunityLeadersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'communityLeaders': (json['communityLeaders'].map(_1.TopCommunityLeaderFromJSON)),
    };
}
exports.GetCommunityLeadersResponseFromJSONTyped = GetCommunityLeadersResponseFromJSONTyped;
function GetCommunityLeadersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'communityLeaders': (value.communityLeaders.map(_1.TopCommunityLeaderToJSON)),
    };
}
exports.GetCommunityLeadersResponseToJSON = GetCommunityLeadersResponseToJSON;
